import { RawContextKey } from '../../contextkey/common/contextkey.js';
const CONTEXT_ACCESSIBILITY_MODE_ENABLED = ( new RawContextKey('accessibilityModeEnabled', false));
function isAccessibilityInformation(obj) {
    return obj && typeof obj === 'object'
        && typeof obj.label === 'string'
        && (typeof obj.role === 'undefined' || typeof obj.role === 'string');
}
const ACCESSIBLE_VIEW_SHOWN_STORAGE_PREFIX = 'ACCESSIBLE_VIEW_SHOWN_';
export { ACCESSIBLE_VIEW_SHOWN_STORAGE_PREFIX, CONTEXT_ACCESSIBILITY_MODE_ENABLED, isAccessibilityInformation };
